import { FormEvent, useState } from "react";
import { supabase } from "../lib/supabase";
import type { CatalogueSearchResult } from "../types";

function euro(value: number | null) {
  if (value === null || value === undefined) return "Sem preço de referência";
  return new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
  }).format(Number(value));
}

export default function Catalogue() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<CatalogueSearchResult[]>([]);
  const [busy, setBusy] = useState(false);
  const [searched, setSearched] = useState(false);
  const [error, setError] = useState("");

  async function search(event: FormEvent) {
    event.preventDefault();
    if (!query.trim()) return;
    setBusy(true);
    setSearched(true);
    setError("");

    const { data, error: rpcError } = await supabase.rpc("search_work_items", {
      search_query: query.trim(),
      result_limit: 30,
    });

    if (rpcError) {
      setError(rpcError.message);
      setResults([]);
    } else {
      setResults((data ?? []) as CatalogueSearchResult[]);
    }
    setBusy(false);
  }

  return (
    <section className="stack-xl">
      <header className="page-header">
        <div>
          <p className="eyebrow">Catálogo normalizado</p>
          <h2>Trabalhos L37</h2>
          <p className="muted">
            Esta área será a base estável de artigos L37. O histórico não entra
            automaticamente no catálogo sem validação.
          </p>
        </div>
      </header>

      <form className="search-panel card" onSubmit={search}>
        <div className="search-main">
          <label className="grow">
            <span>Pesquisar artigo L37</span>
            <input
              type="search"
              placeholder="Nome, descrição ou sinónimo…"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
          </label>
          <button className="button button-primary search-button" type="submit" disabled={busy}>
            {busy ? "A procurar…" : "Pesquisar"}
          </button>
        </div>
      </form>

      {error ? <div className="alert alert-error">{error}</div> : null}

      {searched && !busy && !error && results.length === 0 ? (
        <div className="empty card">
          <strong>O catálogo ainda está vazio.</strong>
          <span>
            Isto é intencional: primeiro importámos as fontes históricas. A próxima
            fase é normalizar e aprovar os trabalhos recorrentes.
          </span>
        </div>
      ) : null}

      <div className="result-list">
        {results.map((item) => (
          <article className="catalogue-row card" key={item.id}>
            <div>
              <div className="result-meta">
                <span className="pill">{item.unit}</span>
                <span>{item.code}</span>
                {item.category_name ? <span>{item.category_name}</span> : null}
              </div>
              <h3>{item.name}</h3>
              {item.normalized_description ? (
                <p className="muted">{item.normalized_description}</p>
              ) : null}
            </div>
            <div className="catalogue-price">
              <span>PU seco referência</span>
              <strong>{euro(item.reference_dry_unit_price)}</strong>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
